// MUI
import { Grid, Typography } from "@mui/material";

// Components
import AssigneesList from "./AssigneesList";

// Types
import { IEmployeeDetails } from "@PayPlans/types/historical";

type AssigneesHistoryProps = {
	assigneesDetailsList: IEmployeeDetails[];
};
export default function AssigneesHistory(props: AssigneesHistoryProps) {
	const { assigneesDetailsList = [] } = props;

	return (
		<Grid container direction="column" className="!ml-4">
			<Typography className="group-pay-plan-assign-container-title">Assignees</Typography>
			<AssigneesList assigneesDetailsList={assigneesDetailsList} />
		</Grid>
	);
}
